import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'PROPERTY_GROUP' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/propertyGroup/handlers.js